import { render, staticRenderFns } from "./BackdateAttendance.vue?vue&type=template&id=2256fd38&scoped=true"
import script from "./BackdateAttendance.vue?vue&type=script&lang=js"
export * from "./BackdateAttendance.vue?vue&type=script&lang=js"
import style0 from "./BackdateAttendance.vue?vue&type=style&index=0&id=2256fd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256fd38",
  null
  
)

export default component.exports